import { Link } from "@mui/material";
import React from "react";
import logoSm from "../../../assets/basicTheme/images/logo-white.png";
import logoLightXSm from "../../../assets/basicTheme/images/log-xsm-white.png";

const FeedbackHeader = () => {
  return (
    <React.Fragment>
      <header id="page-topbar" className="page-hdr-top" style={{ left: 0 }}>
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box" style={{ width: "auto", textAlign: "left", paddingLeft: "12px" }}>
              <Link to="/" className="logo">
                <span className="logo-lg">
                  <img src={logoSm} alt="" height="35" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default FeedbackHeader;
